import { createElement } from 'react'
import { createRoot } from 'react-dom/client'

interface LoadContainerOpts {
	name: string
	props: any,
	propSelectors: string[],
}

export default async (
	el: HTMLElement,
	$el: JQuery<HTMLElement>,
	opt: LoadContainerOpts,
) => {
	const { default: Component } = await import(
		`../containers/${opt.name}/index.tsx`
	)

	let passedProps: any = {}

	if (opt.propSelectors) {
		opt.propSelectors.forEach(propSelector => {
			const _el: any = document.querySelector(propSelector)
			if (_el) {
				passedProps[_el.dataset.propkey] = JSON.parse(_el.innerHTML)
			}
		})
	}

	createRoot(el).render(createElement(Component, {...opt.props, ...passedProps}))
}
